import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartLegend,
  ChartTooltip
} from "@progress/kendo-react-charts";
import { useEffect } from "react";

const AssetAllocationChart = ({ data }) => {

  if (!data || data.length === 0) {
    return <div>No Data</div>;
  }

  const chartData = data.filter(item => !item.isTotalPortfolio);

useEffect(() => {
    const updateChartPosition = () => {
        const chartContainer = document.getElementById("assetAllocationChart");

        if (!chartContainer) return;

        const totalWidth = chartContainer.offsetWidth;
        const chartWidth = 520;
        const chartStartingPosition = (totalWidth / 2) - (chartWidth / 2);

        let style = document.querySelector(
            'style[asset-allocation-chart="true"]'
        );

        if (!style) {
            style = document.createElement("style");
            style.setAttribute("asset-allocation-chart", "true");
            document.head.appendChild(style);
        }

        style.innerHTML = `
            .asset-allocation-chart-wrapper {
                position: absolute;
                left: ${chartStartingPosition}px;
                top: 0;
                width: ${chartWidth}px;
            }
        `;
    };

    updateChartPosition();

    window.addEventListener("resize", updateChartPosition);

    return () => {
        window.removeEventListener("resize", updateChartPosition);

        const style = document.querySelector(
            'style[asset-allocation-chart="true"]'
        );

        if (style) {
            style.remove();
        }
    };
}, []);

  return (
    <div className="asset-allocation-container">
      <div className="asset-allocation-chart-wrapper">
        <Chart style={{ width: "100%", height: "100%" }}>
          <ChartLegend
            position="right"
            labels={{
              font: "16px Arial"
            }}
          />

          <ChartTooltip format="{0:P2}" />

          <ChartSeries>
            <ChartSeriesItem
              type="donut"
              data={chartData}
              field="percentage"
              categoryField="strategyName"
              overlay={{ gradient: "none" }}
              border={{ width: 2, color: "white" }}
              holeSize={125}
              colorField="colorCode"
            />
          </ChartSeries>
        </Chart>
      </div>
    </div>
  );
};

export default AssetAllocationChart;
